module.exports = __webpack_public_path__ + "assets/img/ic-game.df78f205.svg";